export const BTN_FOOTER = {
  style: 'border-radius: 10px !important; height: 50px !important; min-width: 300px !important; max-width: 300px !important;',
};